<template>
  <FormViewBase title="This link has expired.">
    <template #default>
      <div class="title"
        >But don't worry, we've sent another verification email that you should
        receive in the next few minutes. Keep an eye out for that and follow the
        link once you see it!</div
      >
    </template>
    <template #actions>
      <v-btn
        to="/"
        large
        color="blue darken-2 white--text"
        depressed
        block
        class="my-4"
        >View the Homepage</v-btn
      >
    </template>
  </FormViewBase>
</template>

<script>
import FormViewBase from '@/views/FormViewBase'
export default {
  name: 'EmailVerificationExpiredView',
  props: {},
  components: { FormViewBase },
  methods: {},
  data() {
    return {}
  },
}
</script>
